import { render } from "./CounselingReportSearch.vue?vue&type=template&id=3066d7a6&ts=true"
import script from "./CounselingReportSearch.vue?vue&type=script&lang=ts"
export * from "./CounselingReportSearch.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__